import { authFetch } from 'shared/api/authFetch';
import { config } from 'shared/config/config';

const BASE = () => `${config.API_URL}/api/person-senders`;

async function read(response, fallback) {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = payload?.detail;
    const error = new Error(typeof detail === 'string' ? detail : detail?.message || fallback);
    // A level that needs reading Google has not granted yet: sign in again for this access.
    if (detail?.sign_in_for) error.signInFor = detail.sign_in_for;
    throw error;
  }
  return payload;
}

const json = (method, body) => ({
  method,
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

/** The caller's own addresses; a Superadmin gets everyone's, each with its owner's name. */
export async function listSenders() {
  return read(await authFetch(BASE()), 'Sending addresses are temporarily unavailable.');
}

/** The addresses an Automation may send from (for whoever configures Automations). */
export async function listSendersForAutomation(automationId) {
  const query = new URLSearchParams({ allowed_for_automation: String(automationId) });
  return read(await authFetch(`${BASE()}?${query}`), 'The addresses this Automation may use could not be loaded.');
}

/** Google's sign-in page; access (write, read or read_write) says what Google is asked for. */
export async function startGoogleSignin(address, access = 'write') {
  return read(
    await authFetch(`${BASE()}/google/start`, json('POST', { address, access })),
    'Google sign-in could not be started.',
  );
}

export async function completeGoogleSignin({ code, state }) {
  return read(
    await authFetch(`${BASE()}/google/complete`, json('POST', { code, state })),
    'The address could not be connected.',
  );
}

export async function updateSender(senderId, fields) {
  return read(
    await authFetch(`${BASE()}/${encodeURIComponent(senderId)}`, json('PATCH', fields)),
    'The address could not be changed.',
  );
}

export async function disconnectSender(senderId) {
  return read(
    await authFetch(`${BASE()}/${encodeURIComponent(senderId)}`, { method: 'DELETE' }),
    'The address could not be disconnected.',
  );
}
